import { Slots } from "vue";
import { isFunction } from "@/utils/is";

export const getSlot = (slots: Slots, slot = "default", data?: Recordable) => {
  // Reflect.has 判断一个对象是否存在某个属性
  if (!slots || !Reflect.has(slots, slot)) {
    return null;
  }
  if (!isFunction(slots[slot])) {
    console.error(`${slot} is not a function!`);
    return null;
  }
  const slotFn = slots[slot];
  if (!slotFn) return null;
  return slotFn(data);
};

export const toObj = (dataStr: string | null, defaultValue: any = undefined): any => {
  if (dataStr === null) {
    return dataStr;
  }

  try {
    return JSON.parse(dataStr); // 尝试将字符串解析为 JSON 对象
  } catch (error) {
    // 如果无法解析为 JSON 对象，根据需求添加其他数据类型的处理逻辑
    if (dataStr.toLowerCase() === "true") {
      return true;
    } else if (dataStr.toLowerCase() === "false") {
      return false;
    } else if (/\d+\.\d+/.test(dataStr) || /e|E/.test(dataStr)) {
      const parsedFloat = parseFloat(dataStr);
      if (!isNaN(parsedFloat)) {
        return parsedFloat;
      }
    } else {
      const parsedInt = parseInt(dataStr, 10);
      if (!isNaN(parsedInt)) {
        return parsedInt;
      }
    }

    // 如果无法转换为其他基本类型，则返回原始字符串
    return defaultValue != undefined ? defaultValue : dataStr;
  }
};
